import { Grid, Typography } from "@mui/material";

import PostInputCard from "./postInputCard";
import PostCard from "../../components/PostCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useCallback, useEffect, useState } from "react";
import { getPosts } from "../../store/slices/posts";
import BirthdaysCard from "./BirthdaysCard";
import RecognitionCard from "./RecognitionCard";
import MySnackbar from "../../components/MySnackbar";
import backgroundImage from "../../assets/images/posts/v2.png";
import ThreeComponent from "../../components/ThreeColumnsComponent";


// const mediaQuery = window.matchMedia('(max-width: 900px)');


const HeaderComponent = () => {
    return (
        <Grid
        container
        style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "right center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            height: "11.25rem",
            borderRadius: "0.5rem",
            width: "100%",
            padding: "1rem",
        }}
        direction={"column"}
        justifyContent={"flex-end"}
        >
        <Typography 
            variant="h5" 
            sx={{
                color: {xs: "black", xl: "white"},
                textShadow: {
                  xs: "1px 1px 2px white",
                  xl: "1px 1px 2px black",
                },
            }}
        >
            Bienvenidos a S10
        </Typography>
        <Typography 
            variant="subtitle1" 
            sx={{
                color: {xs: "black", xl: "white"},
                textShadow: {
                  xs: "1px 1px 2px white",
                  xl: "1px 1px 2px black",
                },
            }}
        >
            El sistema de trámites y beneficios del personal
        </Typography>
        </Grid>
    )
}

const PostsColumns = ({setErrorMsg, setSuccessMsg}: any) => {
    
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {birthdaysData, recognitions, ...postsState} = useSelector((state: RootState) => state.posts);

    useEffect(() => {
        if (companyselected?.Code && !postsState.loadingPosts) {
            dispatch(getPosts({postType: 'post'}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Code])

    return (
        <Grid 
            container 
            item 
            justifyContent={"center"} 
            alignContent={"start"} 
        >
            <Grid 
                item
                container
                // sx={{ display: { xs: 'none', md: 'block' }, p: 0, m: 0 }}
            >
                <HeaderComponent />
            </Grid>
            <Grid 
                item
                container
                style={{margin: "1.5rem 0"}}
            >
                <PostInputCard setErrorMsg={setErrorMsg} />
            </Grid>
            {postsState.posts.data?.map((post) => (
                <Grid 
                    key={post.postId}
                    container
                    style={{margin: "0 0 1.5rem 0"}}
                >
                    <PostCard postData={post} setErrorMsg={setErrorMsg} setSuccessMsg={setSuccessMsg} />
                </Grid>
            ))}
        </Grid>
    )
}

const Posts = () => {

    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const ComponentOne = useCallback(() => (
        <BirthdaysCard title="Cumpleaños" month={0} />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

  
    const ComponentTwo = useCallback(() => (
        <PostsColumns setErrorMsg={setErrorMsg} setSuccessMsg={setSuccessMsg} />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
  
    const ComponentThree = useCallback(() => (
        <RecognitionCard />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

    return (
    <Grid 
        container 
        style={{
            width: "100%",
            backgroundColor: "#F5F5F5", 
            margin: 0,
            // padding: "2rem 2rem 0rem 2rem",
            // marginTop: "1.5rem"
        }}
        spacing={0}
    >
        <ThreeComponent
            tabsTitle={["Cumpleaños", "Publicaciones", "Reconocimientos"]}
            useTabsNameAsTitle={true}
            excludeCardsToComponents={[0, 1, 2]}
            excludeTitleToComponents={[0, 1, 2]}
            ComponentOne={ComponentOne}
            ComponentTwo={ComponentTwo}
            ComponentThree={ComponentThree}
            defaultSelectedTab={1}
            componentsSizes={[{
                xs: 12,
                sm: 6,
                md: 3,
                xl: 2,
            }, {
                xs: 12,
                sm: 6,
                md: 6,
                xl: 8,
            }, {
                xs: 12,
                sm: 6,
                md: 3,
                xl: 2,
            }]}
        />
        <MySnackbar
            open={errorMsg !== ""}
            msg={errorMsg}
            severity="error"
            onClose={() =>  setErrorMsg("")}
        />
        <MySnackbar
            open={successMsg !== ""}
            msg={successMsg}
            severity="success"
            onClose={() =>  setSuccessMsg("")}
        />
    </Grid>);
}

export default Posts;